// extracted by mini-css-extract-plugin
export default {"wrapper":"ColoredChanges_wrapper__JxJu8","changeable":"ColoredChanges_changeable__cUybo","textRight":"ColoredChanges_textRight__hux9a","change":"ColoredChanges_change__kRENA"};